import { render, staticRenderFns } from "./RefsReportGroup.vue?vue&type=template&id=784ee7f4&scoped=true"
import script from "./RefsReportGroup.vue?vue&type=script&lang=ts"
export * from "./RefsReportGroup.vue?vue&type=script&lang=ts"
import style0 from "./RefsReportGroup.vue?vue&type=style&index=0&id=784ee7f4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784ee7f4",
  null
  
)

export default component.exports